export const ENDPOINT_URL = {
  AUTH: "/auth",
  FORM: "/form",
  FEEDBACK_REQUEST: "/feedback-request",
  USER: "/user",
  FEEDBACK: "/feedback",
  NOTES: "/notes",
};
